module.exports = __webpack_public_path__ + "media/images/photos-7c51c2d135d080db1ef24927f136c68f52a60ea900c16bd76eca7a09eb52c870.jpg";